import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { Text, TextType } from 'ui-components/components/text';
import { NotificationService, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import messages from './messages';
import { ActivationModalContent } from '../modal/components';

const BlockedStore = () => {
  useEffect(() => {
    NotificationService.showNotification({
      notificationType: NOTIFICATION_TYPE_ERROR,
      title: <FormattedMessage {...messages.storeOnboardingBlockedTitle} />,
      content: <FormattedMessage {...messages.storeOnboardingBlocked} />,
    });
  }, []);

  return (
    <ActivationModalContent>
      <BannerMessageV2
        content={<Text textType={TextType.Paragraph} value={messages.storeOnboardingBlocked} />}
        layout={BannerLayout.Full}
        status={BannerStatus.Error}
      />
    </ActivationModalContent>
  );
};

export default BlockedStore;
